'use client';

import type { CSSProperties, ReactNode } from 'react';
import type { MerchOrganization } from '../interfaces/merch';

function normalizeHex(color?: string | null): string | undefined {
  if (!color) return undefined;
  const trimmed = color.trim();
  if (/^#[0-9a-fA-F]{3,8}$/.test(trimmed)) return trimmed;
  if (/^[0-9a-fA-F]{3,8}$/.test(trimmed)) return `#${trimmed}`;
  return trimmed;
}

interface MerchStoreThemeProps {
  organization: MerchOrganization;
  children: ReactNode;
}

export function MerchStoreTheme({ organization, children }: MerchStoreThemeProps) {
  const accent = normalizeHex(organization.primary_color) ?? undefined;
  const accentSecondary = normalizeHex(organization.secondary_color) ?? accent;

  const style = {
    ...(accent ? { '--merch-accent': accent } : {}),
    ...(accentSecondary ? { '--merch-accent-secondary': accentSecondary } : {}),
  } as CSSProperties;

  return (
    <div
      className="merch-store-theme [--merch-accent:var(--primary)] [--merch-accent-secondary:var(--primary)]"
      style={style}
    >
      {children}
    </div>
  );
}
